(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trenvelo-product-discovery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-tv-recent-root]');
  if (!root || root.dataset.loaded === 'true') return;
  let ids = [];
  try { ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]'); } catch (e) { ids = []; }
  const current = root.dataset.currentProduct;
  ids = ids.map(String).filter((id) => id && id !== String(current)).slice(0, 8);
  if (!ids.length) return;
  const url = new URL('/search', location.origin);
  url.searchParams.set('q', ids.map((id) => 'id:' + id).join(' OR '));
  url.searchParams.set('resources[type]', 'product');
  url.searchParams.set('section_id', root.dataset.sectionId);
  fetch(url).then((response) => response.text()).then((html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const incoming = doc.querySelector('[data-tv-recent-list]');
    if (!incoming || !incoming.children.length) return;
    const byId = new Map(Array.from(incoming.children).map((el) => [el.dataset.productId, el]));
    const list = root.querySelector('[data-tv-recent-list]');
    ids.forEach((id) => { const card = byId.get(id); if (card) list.append(card); });
    if (!list.children.length) return;
    root.hidden = false;
    root.dataset.loaded = 'true';
  }).catch(() => {});
})();

  } catch(e) { console.error(e); }
})();
})();
